global.Buffer = require('buffer').Buffer;
global.process = require('process');
global.navigator = {
    userAgent: 'React Native'
}